"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class GatewayEvent extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'gatewayEvent';
        this._gatewayId = initParams.gateway_id;
        this._type = initParams.type;
        this._event = initParams.event;
        this._state = initParams.state;
        this._time = initParams.time;
    }
    set gatewayId(value) {
        console.error('Do not set objects this way');
    }
    get gatewayId() {
        return this._gatewayId;
    }
    set type(value) {
        console.error('Do not set objects this way');
    }
    get type() {
        return this._type;
    }
    set event(value) {
        console.error('Do not set objects this way');
    }
    get event() {
        return this._event;
    }
    set state(value) {
        console.error('Do not set objects this way');
    }
    get state() {
        return this._state;
    }
    set time(value) {
        console.error('Do not set objects this way');
    }
    get time() {
        return this._time;
    }
}
exports.default = GatewayEvent;
//# sourceMappingURL=gatewayEvent.js.map